import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LinksSectionComponent } from '@shared/components/links-section/links-section.component';
import { SideNavigationComponent } from '@shared/components/side-navigation/side-navigation.component';
import { IDetails_Response } from '@shared/constants/models.const';
import { BreadcrumbsComponent } from '@shared/components/breadcrumbs/breadcrumbs.component';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { ThreeColumnTemplateComponent } from '@templates/three-column-template/three-column-template.component';
import { RelatedItemsComponent } from '@shared/components/related-items/related-items.component';
import { CkViewerComponent } from '@shared/components/ck-viewer/ck-viewer.component';
import { E_FILE_EXTENSION, E_FILE_PREVIEW } from '@shared/constants/enums.const';
import { TranslateModule } from '@ngx-translate/core';
import { TocComponent } from '@shared/components/toc/toc.component';
import { DefaultPortletsComponent } from '@shared/components/default-portlets/default-portlets.component';

@Component({
  selector: 'app-publication-details',
  imports: [
    LinksSectionComponent,
    SideNavigationComponent,
    BreadcrumbsComponent,
    ThreeColumnTemplateComponent,
    RelatedItemsComponent,
    CkViewerComponent,
    TranslateModule,
    TocComponent,
    DefaultPortletsComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './publication-details.component.html',
  styleUrl: './publication-details.component.scss',
})
export class PublicationDetailsComponent {
  pageData = input<IDetails_Response | any>();
  imageUrl = computed(() => {
    if (this.pageData().thumbnail) {
      return this.pageData().thumbnail.sourceUrl || E_FILE_PREVIEW.placeholder;
    } else {
      if (this.pageData().document?.extension) {
        switch (this.pageData().document?.extension) {
          case E_FILE_EXTENSION.xls:
            return E_FILE_PREVIEW.xls;
          case E_FILE_EXTENSION.docx:
            return E_FILE_PREVIEW.doc;
          default:
            return E_FILE_PREVIEW.placeholder;
        }
      }
    }
    return E_FILE_PREVIEW.placeholder;
  });
  ButtonTypes = BUTTON_TYPES;

}
